module.exports = __webpack_public_path__ + "img/amazon_retail.bdd425a9.svg";